var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"cta-section"},[_c('div',{staticClass:"cta-section__inner"},[_c('p',{staticClass:"cta-section__lead"},[_vm._t("lead",function(){return [_vm._v(_vm._s(_vm.lead))]})],2),_c('div',{staticClass:"cta-section__actions"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }